<div class="dialog-overlay" data-testid="order-status-dialog">
    <div class="dialog-container">
        <button class="close-button" data-testid="order-status-dialog-close" (click)="close()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="#232529" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </button>

        <div class="dialog-content">
            <ng-container *ngIf="data.status && data.status.from && data.status.to">
                <div class="status-container">
                    <div [class]="'status-badge ' + data.status.from.class">
                        {{ data.status.from.text }}
                    </div>
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12.5H19M19 12.5L12 5.5M19 12.5L12 19.5" stroke="#232529" stroke-width="2"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <div [class]="'status-badge ' + data.status.to.class">
                        {{ data.status.to.text }}
                    </div>
                </div>
            </ng-container>
            <img class="dialog-main-icon" [src]="data.mainIcon" alt="">
            <h2 class="dialog-title" data-testid="order-status-dialog-title">{{ data.title }}</h2>
            <p class="dialog-description">
                <span *ngIf="data.misProducts && data.misProducts.length > 0">{{data.misProducts.length}} </span>
                {{ data.description }}
            </p>
            <div class="dialog-warning" *ngIf="data.warning">
                <ui-svg-icon svgIcon="ai-volta-icon" size="medium"></ui-svg-icon>
                <span>{{ data.warning }}</span>
            </div>
        </div>

        <ng-container *ngIf="data.misProducts && data.misProducts.length > 0">
            <div class="product-list-container">
                <div class="product-item" *ngFor="let product of data.misProducts">
                    <div class="product-icon">
                        <svg width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 11.5339L7 4.61385M1.36 8.28052L13 15.0139L24.64 8.28052M13 28.4405V15.0005M25 20.3339V9.66719C24.9995 9.19955 24.8761 8.74027 24.6421 8.3354C24.408 7.93054 24.0717 7.59434 23.6667 7.36052L14.3333 2.02719C13.9279 1.79314 13.4681 1.66992 13 1.66992C12.5319 1.66992 12.0721 1.79314 11.6667 2.02719L2.33333 7.36052C1.92835 7.59434 1.59197 7.93054 1.35795 8.3354C1.12392 8.74027 1.00048 9.19955 1 9.66719V20.3339C1.00048 20.8015 1.12392 21.2608 1.35795 21.6656C1.59197 22.0705 1.92835 22.4067 2.33333 22.6405L11.6667 27.9739C12.0721 28.2079 12.5319 28.3311 13 28.3311C13.4681 28.3311 13.9279 28.2079 14.3333 27.9739L23.6667 22.6405C24.0717 22.4067 24.408 22.0705 24.6421 21.6656C24.8761 21.2608 24.9995 20.8015 25 20.3339Z" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="product-details">
                        <span class="product-name">{{ product.product_name }}</span>
                        <span class="product-sku">{{ (product | productCode:'') ? (productCode.labelKey(product) | translate) + ': ' + (product | productCode) : '' }}</span>
                    </div>
                </div>
            </div>
    
            <p class="popup-additional-message">{{ data.erp_description }}</p>
        </ng-container>

        <ng-container *ngIf="data.misInventory && data.misInventory.length > 0">
            <div class="product-list-container">
                <div class="product-item" *ngFor="let product of data.misInventory">
                    <div class="product-icon">
                        <svg width="26" height="30" viewBox="0 0 26 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19 11.5339L7 4.61385M1.36 8.28052L13 15.0139L24.64 8.28052M13 28.4405V15.0005M25 20.3339V9.66719C24.9995 9.19955 24.8761 8.74027 24.6421 8.3354C24.408 7.93054 24.0717 7.59434 23.6667 7.36052L14.3333 2.02719C13.9279 1.79314 13.4681 1.66992 13 1.66992C12.5319 1.66992 12.0721 1.79314 11.6667 2.02719L2.33333 7.36052C1.92835 7.59434 1.59197 7.93054 1.35795 8.3354C1.12392 8.74027 1.00048 9.19955 1 9.66719V20.3339C1.00048 20.8015 1.12392 21.2608 1.35795 21.6656C1.59197 22.0705 1.92835 22.4067 2.33333 22.6405L11.6667 27.9739C12.0721 28.2079 12.5319 28.3311 13 28.3311C13.4681 28.3311 13.9279 28.2079 14.3333 27.9739L23.6667 22.6405C24.0717 22.4067 24.408 22.0705 24.6421 21.6656C24.8761 21.2608 24.9995 20.8015 25 20.3339Z" stroke="#1E1E1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <div class="product-details qty-div">
                        <span class="product-name">{{ product.product_name }}</span>
                        <span class="product-sku">{{ (product | productCode:'') ? (productCode.labelKey(product) | translate) + ': ' + (product | productCode) : '' }}</span>
                    </div>
                    <div class="product-details-container">
                        <div class="product-details qty-div">
                            <span class="product-name">{{ product.erp_qty }} {{ 'quotations_and_orders.status_dialog.product_details.units' | translate }}</span>
                            <span class="product-sku">{{ 'quotations_and_orders.status_dialog.product_details.available' | translate }}</span>
                        </div>
                        <div class="product-details qty-div">
                            <span class="product-name">{{ product.order_qty }} {{ 'quotations_and_orders.status_dialog.product_details.units' | translate }}</span>
                            <span class="product-sku">{{ 'quotations_and_orders.status_dialog.product_details.ordered' | translate }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
        
        <!--
          `ui-checkbox` renders only the box, so the label is a sibling and the whole
          row carries the click. The box stops propagation on its own click, so a hit
          on the box toggles once here and a hit on the text toggles once via the row.
        -->
        <div class="dialog-preference" *ngIf="data.checkbox" (click)="onCheckboxToggle(!data.checkbox.checked)">
            <ui-checkbox
                [checked]="data.checkbox.checked"
                [ariaLabel]="data.checkbox.label"
                (changed)="onCheckboxToggle($event.checked)">
            </ui-checkbox>
            <span class="dialog-preference__label">{{ data.checkbox.label }}</span>
        </div>

        <div class="dialog-actions">
            <ng-container *ngFor="let action of data.actions">
                <button [class]="'action-button ' + action.class" [attr.data-testid]="'order-status-dialog-' + action.class" (click)="action.callback()" [style]="'display: flex;'">
                    <img *ngIf="action.icon && action.icon.position === 'before'" [src]="action.icon.name" alt="">
                    <span class="action-label">{{ action.label }}</span>
                    <ng-container *ngIf="action.icon && action.icon.position === 'after'">
                        <img *ngIf="action.icon.name.includes('/')" [src]="action.icon.name" alt="">
                        <mat-icon *ngIf="!action.icon.name.includes('/')">{{ action.icon.name }}</mat-icon>
                    </ng-container>
                </button>
            </ng-container>
        </div>
    </div>
</div>